<template>
	<div class="overflow-remove contact-page-bg">
		<div class="text-left contact-information-stepper w-100">
			<div class="assessmentSection">
				<div class="row">
					<div class="col-3"></div>
					<div class="col-6">
						<div class="assessmentdiv">
							<h4>Interview Import</h4>
							<div class="assessmentdivbody">
								<b-form class="contact-form-step1">
									<label class="color-dark-grey">Enter the UID: <span class="red">*</span></label> 
									<b-form-group>
										<b-form-input
										v-model="form.enterPID"
										type="text"
										placeholder="Enter ..."
										autocomplete="off"
										:disabled="inputdisablestatus"
										/>
									</b-form-group>
									<div class="DownloadImportTemplate">
										<div v-if="ImportBtn">
											<span v-if="afterImport" class="ImportProspectInput btn btn-primary btn-file">
												Import File <input type="file" id="file2" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" :disabled="disabledStatus"
												@change="onChangeAssessmentFileImport" :key="fileInputKey" required>
											</span>
											<div v-else class="loader-blue submitimportbtnloader"><div class="loader4"></div></div>
											<xlsx-read :file="file">
											<xlsx-json>
												<template #default="{collection}">
												<div>{{ AssessmentImportDataCollection(collection) }}</div>
												</template>
											</xlsx-json>
											</xlsx-read>
										</div>
										<div class="DownloadImportTemplate">
											<div v-if="SubmitImportLoader" class="loader-blue submitimportbtnloader"><div class="loader4"></div></div>
											<b-button v-if="SubmitImportBtn" type="submit" variant="outline-primary" @click.stop.prevent="fetchProspectsButton()">Submit</b-button>
											<b-button v-if="finalImportProcessBtn" type="submit" variant="outline-primary" @click.stop.prevent="finalImportProcess()">Next</b-button>
										</div>
										<b-button v-if="clearProspectImportbtn" variant="outline-primary" @click.stop.prevent="clearProspectImport()">Clear</b-button>
									</div>
								</b-form> 
								<div v-if="foundExistingProsDiv" style="text-align:center;">Found {{this.foundExistingPros}} Prospects</div>
								<div v-if="updatedCCIDiv" style="text-align:center;">{{this.updatedCCI}} Prospects Updated</div>
							</div>
						</div>
					</div>
					<div class="col-3"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import { db } from 'src/db'
	import { mapState } from 'vuex'
	import axios from "axios";
	import { XlsxRead, XlsxJson } from "vue-xlsx/dist/vue-xlsx.es.js"
	export default {
		name: "InterviewImport",
		components: {
			XlsxRead,
			XlsxJson
		},
		computed: {
            ...mapState('firebase', ['prospects'])
        },
		methods: {
			// INITIALIZE
			ResetInitVal() {
				this.importcollection=[];
				this.disabledStatus = false;
				this.keyHeader = [];
				this.valueHeader = [];
				this.existingProspects = [];
				this.userDocData = [];
				this.updatedCCIDiv=false;
				this.userDocId='';
				this.finalImportProcessBtn=false;
				this.foundExistingPros=0;
				this.foundExistingProsDiv=false;
				this.inputdisablestatus=false;
			},
			// CLEAR
			clearProspectImport() {
				this.ResetInitVal();
				this.SubmitImportLoader = false;
				this.SubmitImportBtn = true;
				this.ImportBtn=false;
				this.clearProspectImportbtn=false;
				this.form.enterPID = '';
				this.updatedCCI=0;
				this.afterImport = true;
			},
			// ON CLICK UID CHECK PROSPECTS
			fetchProspectsButton() {
				this.ResetInitVal();
				var enterPID = this.form.enterPID;
				if(enterPID && enterPID.length > 22) {
					this.SubmitImportLoader = true;
					this.SubmitImportBtn = false;
					this.getUserDetails(enterPID);
				} else {
					alert('Please enter the correct UID and process.');
					this.form.enterPID = '';
				}
			},
			// API: GET CURRENT USER DETAILS
			getUserDetails(enterPID) {
				const searchUser = {
					searchBy:'Uid',
					searchValue:enterPID,
				};
				axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/getUser", searchUser)
				.then(response => {
					this.userDocData = response.data[0];
					this.userDocId = response.data[0].id;
					this.GetProspectsAccordingToUID();
					//eslint-disable-next-line
					//console.log('this.userDocData', this.userDocData);
					//eslint-disable-next-line
					//console.log('this.userDocId', this.userDocId);
				}).catch(err => alert(`Failure getting user match: ${err}`));
			},
			// API: GET ALL PROSPECTS ACCORDING UID
			async GetProspectsAccordingToUID() {
				const searchUser = {
					pid: this.userDocId,
				};
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/getProspectListByDocID", searchUser)
				.then(response => {
					this.UIDprospects = response.data;
					//eslint-disable-next-line
					console.log('response: ',response);
					//eslint-disable-next-line
					console.log('UIDprospects: ',this.UIDprospects);
					this.SubmitImportLoader = false;
					this.SubmitImportBtn = false;
					this.ImportBtn = true;
					this.clearProspectImportbtn=true;
					this.inputdisablestatus=true;
				}).catch(err => alert(`Failure getting existing prospect match: ${err}`));
			},
			// ON CHANGE ASSESSMENT IMPORT
			onChangeAssessmentFileImport(event) {
				var fileName = document.querySelector('#file2').value;
				var extension = fileName.split('.').pop();
				if(extension == 'csv' || extension == 'xlsx' || extension == 'xls') {
					if(this.form.enterPID && this.form.enterPID.length > 22) {
						this.file = event.target.files ? event.target.files[0] : null;
						this.afterImport = false;
						setTimeout(() => {
							this.AssessmentImportDataValidation();
						}, 100);
					} else {
						alert('Please enter the correct UID and process.');
						this.form.enterPID = '';
					}
				} else {
					this.fileInputKey++;
					alert('Import file must be in a .csv, .xls, or .xlsx format');
				}
			},
			AssessmentImportDataCollection(collection) {
				this.importcollection = collection;
			},
			// CHECK NUMBER VALIDATION
			checkPhoneNumberValidation() {
				if(this.keyHeader.includes('Phone Number')) {
					let idexno = this.keyHeader.indexOf('Phone Number');
					var numberget = ''+this.valueHeader[idexno]+'';
					var countDash = numberget.split("-").length - 1;
					if(countDash == 2) {
					var newStrNumber = numberget.replace(/-/g, ""); 
						this.valueHeader[idexno] = '+1'+newStrNumber;
					} else {
						this.valueHeader[idexno] = this.$parseNumber(numberget);
					}
				}
			},
			// RENAME KEY NAME
			renameProperty(obj, oldName, newName) {
				obj[newName] = obj[oldName];
				delete obj[oldName];
			},
			AssessmentImportDataValidation() {
				this.afterImport = true;
				if(this.importcollection && this.importcollection.length) {

					for(var k=0; k<this.importcollection.length; k++) {
						this.keyHeader = Object.keys(this.importcollection[k]);
						this.valueHeader = Object.values(this.importcollection[k]);
						this.checkPhoneNumberValidation();
						this.importcollection[k]['Phone Number'] = this.valueHeader[0];

						const utcValue = (Math.floor(this.valueHeader[1] - 25569) * 86400);
						const convertEpoch = new Date(utcValue * 1000).valueOf();
						this.importcollection[k]['Interview Date'] = convertEpoch + (3600000*9);

						this.renameProperty(this.importcollection[k], 'Interview Date', 'Interviewed');
						this.renameProperty(this.importcollection[k], 'Interview Rating', 'InterviewScore');
						this.renameProperty(this.importcollection[k], 'Phone Number', 'Number');

						if(this.importcollection[k].Number) {
							let FilterByGetData = this.UIDprospects.find(ps => ps.Number == this.importcollection[k].Number);
							if(FilterByGetData) {
								this.importcollection[k]['id'] = FilterByGetData.id;
								this.existingProspects.push(this.importcollection[k]);
							}
						}
					}
					
					//eslint-disable-next-line
					// console.log('Latest Import Collection:', this.importcollection);

					this.ImportBtn=false;
					this.foundExistingProsDiv=true;
					this.foundExistingPros = this.existingProspects.length;
					if(this.foundExistingPros>0) {
						this.finalImportProcessBtn=true;
					}
				}
			},
			// FINAL IMPORT PROCESS BTN
			finalImportProcess() {
				this.foundExistingProsDiv=false;
				this.finalImportProcessBtn=false;
				this.updatedCCIDiv = true;
				this.ImportBtn=false;
				this.SubmitImportLoader = true;
				this.clearProspectImportbtn=false;

				//eslint-disable-next-line
				console.log('existingProspects:', this.existingProspects);

				this.existingProspects.forEach(element2 => {
					//eslint-disable-next-line
					console.log("element2", element2.Number);
					let updatedForm = { InterviewScore: element2.InterviewScore, Interviewed:element2.Interviewed }
					//eslint-disable-next-line
					console.log("updatedForm", updatedForm);
					db.doc(`Users/${this.userDocData.id}/Prospects/${element2.id}`).update(updatedForm);
					this.updatedCCI = this.updatedCCI + 1;

					if(this.updatedCCI == this.existingProspects.length) {
						this.SubmitImportLoader = false;
						this.clearProspectImportbtn=true;
					}
				});
			},

			
		},
		data() {
			return {
				file: null,
				fileInputKey: 0,
				UIDprospects:[],
				form: {
					enterPID: '',
				},
				importcollection:[],
				disabledStatus: false,
				keyHeader:[],
				valueHeader:[],
				SubmitImportLoader:false,
				SubmitImportBtn:true,
				ImportBtn:false,
				clearProspectImportbtn:false,
				existingProspects:[],
				userDocData:[],
				updatedCCI:0,
				updatedCCIDiv:false,
				userDocId:'',
				finalImportProcessBtn:false,
				foundExistingPros:0,
				foundExistingProsDiv:false,
				inputdisablestatus:false,
				afterImport: true,
			}
        }
    }
</script>

<style scoped>
.red{
	color:red;
}
.assessmentSection{
	padding: 8% 5%;
}
.DownloadImportTemplate{
	text-align: center;
	margin: 30px;
}
.DownloadImportTemplate .btn-outline-primary{
    padding: 8px 30px;
	height: auto;
}
.ImportProspectInput{
	color: #007bff;
    background-color: transparent;
    border-color: #007bff;
	cursor: pointer;
	padding: 10px 30px;
	position: relative;
    overflow: hidden;
}
.ImportProspectInput.btn-primary:hover {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}
.ImportProspectInput input[type=file] {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 100%;
    min-height: 100%;
    font-size: 100px;
    text-align: right;
    filter: alpha(opacity=0);
    opacity: 0;
    outline: none;   
    cursor: inherit;
    display: block;
}
.loader4 {
   width:30px;
   height:30px;
   display:inline-block;
   padding:0px;
   border-radius:100%;
   border:5px solid;
   border-top-color:#fff;
   border-bottom-color:rgba(255,255,255, 0.3);
   border-left-color:#fff;
   border-right-color:rgba(255,255,255, 0.3);
   -webkit-animation: loader4 1s ease-in-out infinite;
   animation: loader4 1s ease-in-out infinite;
}
.loader-blue .loader4{
    border-top-color:#06187c;
   border-bottom-color:rgba(255,255,255, 0.3);
   border-left-color:#06187c;display: flex;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 0;
    bottom: 0;
   border-right-color:rgba(255,255,255, 0.3);
}
.loader-blue{
    position: absolute;
    padding-left: 0px;
    top: 0;z-index: 9999;
    margin: auto;
    bottom: 0;
}
@keyframes loader4 {
   from {transform: rotate(0deg);}
   to {transform: rotate(360deg);}
}
@-webkit-keyframes loader4 {
   from {-webkit-transform: rotate(0deg);}
   to {-webkit-transform: rotate(360deg);}
}
.submitimportbtnloader{
	position: relative;
    padding: 22px;
    display: inline-block;
    width: 18%;
    color: #007bff;
    border: 1px solid #007bff;
    border-radius: 5px;
}
.assessmentdiv h4{
	padding: 20px;
    font-size: 20px;
    background-color: #e6e6e6;
    text-align: center;
	margin-bottom:0px;
}
.assessmentdiv {
	background: #fff;
    border-radius: 4px;
    box-shadow: 1px 2px 8px 1px #dde;
}
.assessmentdivbody{
    padding: 40px;
}
</style>